
  import { Component, OnInit,Input,TemplateRef } from '@angular/core';
  import { FormGroup,Validators} from '@angular/forms';
  import { SetService } from 'ngx-block-core';



  
  @Component({
    selector: 'tableformdiv',
    templateUrl: './tableformdiv.component.html',
    styleUrls: ['./tableformdiv.component.less']
  })
  export class TableformdivComponent implements OnInit {
    @Input() form: FormGroup;
    @Input() nzFormGroupData;
    @Input() sets;
    @Input() nzBlock: TemplateRef<void>;
    constructor(public setService:SetService) { }
  
    ngOnInit() {
    }
  
  }